export default {"src":"/_next/static/media/safety-security-section.b1e9c13f.gif","height":700,"width":700};